import enUS from './en-US.js'
import store from '@/store/index.js';
import smCom from '../../../common/global/smCom.js'
// 安全获取语言设置，防止djsAdmin不存在
const sLng = (store.state && store.state.djsAdmin && store.state.djsAdmin.lng) || 'zh-CN';




const fLng = (sKey, sModule) => {
  let sVal;
  if (sLng == 'zh-CN') {
    sVal = sKey
  }
  if (sLng == 'en-US' && !smCom.fSmIsEmpty(enUS[sModule])) {
    sVal = enUS[sModule][sKey]
  }
  if (smCom.fSmIsEmpty(sVal)) {
    return sKey
  }
  return sVal
}



export default fLng



// WEBPACK FOOTER //
// ./src/assets/lng/lng.js